import { SearchOutlined } from '@ant-design/icons';
import { Select, Space, Tag, Tooltip } from 'antd';
import { Loader } from 'components/Global';
import Buttons from 'components/Global/Buttons';
import DatePickerField from 'components/Global/DatePicker';
import SearchComponent from 'components/Global/SearchComponent';
import { DownloadSvg } from 'utils/svgs';
import styles from './index.module.scss';
import SelectDropdown from 'components/Global/SelectDropdown';

type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	dateValue: any;
	handleDatePicker: any;
	totalRecords: number;
	downloadLoanCsv: any;
	downloadLoading: boolean;
	selectedCount?: number;
	selectedCurrency?: 'ZMW' | 'USD';
	onBulkPayment: () => void;
	selectedPaymentMethod: string;
	setSelectedPaymentMethod: any;
};

const LoanRequestTableHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		handleDatePicker,
		dateValue,
		totalRecords,
		downloadLoanCsv,
		downloadLoading,
		selectedCount = 0,
		selectedCurrency = 'ZMW',
		onBulkPayment,
		selectedPaymentMethod,
		setSelectedPaymentMethod,
	} = props;
	const bulkPaymentButton = [
		{
			text: `Bulk Payment (${selectedCurrency})`,
			isLoading: false,
			className: 'btn-blue',
			isSubmit: true,
			onclick: onBulkPayment,
			disabled: selectedCount === 0,
		},
	];

	const paymentMethodOptions = [
		{
			label: 'All',
			value: '',
		},
		{
			label: 'Cash',
			value: 'cash',
		},
		{
			label: 'Bank',
			value: 'bank',
		},
	];
	return (
		<div className={styles['loan-request-header']}>
			<Space>
				<SearchComponent
					className={styles['loan-request-header-item']}
					placeHolder="Search by code or name"
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<DatePickerField
					name={'dateFilter'}
					value={dateValue}
					required={false}
					picker="month"
					isError={false}
					onChange={handleDatePicker}
				/>
				<Select
					className={styles['loan-request-header-item']}
					value={selectedPaymentMethod}
					options={paymentMethodOptions}
					onChange={(value) => {
						setSelectedPaymentMethod(value);
					}}
					size="large"
					placeholder="Select payment Method"
					style={{
						maxWidth: '200px',
					}}
				/>
			</Space>
			<div className={styles['loan-request-header__buttons']}>
				{selectedCount > 1 && (
					<>
						<div style={{ marginRight: '10px' }}>
							<Buttons buttons={bulkPaymentButton} />
						</div>
					</>
				)}
				{/* {bulkPaymentVisible && <Buttons buttons={headerButtons} />} */}
				{totalRecords > 0 ? (
					<div
						style={{
							marginRight: '10px',
						}}
					>
						<Tooltip title="Download Excel with loan Data">
							<p
								className={styles['csv-button']}
								onClick={
									!downloadLoading
										? downloadLoanCsv
										: undefined
								}
							>
								{downloadLoading ? (
									<>
										<Loader />
									</>
								) : (
									<DownloadSvg />
								)}
							</p>
						</Tooltip>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default LoanRequestTableHeader;
